module.exports = __webpack_public_path__ + "img/boluochi1.ccbb8a1b.png";